import styled from 'styled-components'

export default styled.div`
  margin-top: 10px;
  text-align: right;
  width: 100%;
`
